<template>
    <DxDataGridInstalaciones :dxDataSourceProp="dxDataGridSource" />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type CustomStore from 'devextreme/data/custom_store';
import DxDataGridInstalaciones from "./DxDataGridInstalaciones.vue";

const props = defineProps<{ dxDataSourceProp: CustomStore | undefined }>();
const dxDataGridSource = computed(() => props.dxDataSourceProp);
</script>